import React, { useContext } from 'react';
import "./Why_Choose_Ambassadeur.css";
import Common_subHeading from '../../common_components/common_subHeading/Common_subHeading';
import Pink_box from '../../common_components/pink_box/Pink_box';
import { Context } from '../../../utils/context';

function Why_Choose_Ambassadeur() {

  const {language} = useContext(Context);

  const ambassadeur = [
  {
    heading:
      language == 1
        ? "Multi-destination pathways"
        : "Parcours multi-destinations",
    desc:
      language == 1
        ? "Guidance across France, USA, Georgia & Korea"
        : "Accompagnement vers la France, les États-Unis, la Géorgie et la Corée",
  },
  {
    heading:
      language == 1
        ? "Strong institutional network"
        : "Réseau institutionnel solide",
    desc:
      language == 1
        ? "Trusted partnerships and reliable processes"
        : "Partenariats fiables et processus de confiance",
  },
  {
    heading:
      language == 1
        ? "Transparent & ethical support"
        : "Accompagnement transparent et éthique",
    desc:
      language == 1
        ? "No false promises. No hidden fees—only structured guidance"
        : "Aucune fausse promesse. Aucun frais caché — uniquement un accompagnement structuré",
  },
  {
    heading:
      language == 1
        ? "Personalised program matching"
        : "Matching de programmes personnalisé",
    desc:
      language == 1
        ? "Based on interest, budget, and academic background"
        : "Basé sur les intérêts, le budget et le parcours académique",
  },
  {
    heading:
      language == 1
        ? "Support before & after departure"
        : "Accompagnement avant et après le départ",
    desc:
      language == 1
        ? "Students are never alone—AFI guides the full journey"
        : "Les étudiants ne sont jamais seuls — AFI accompagne tout le parcours",
  },
  {
    heading:
      language == 1
        ? "Academic + cultural growth"
        : "Développement académique et culturel",
    desc:
      language == 1
        ? "We focus on outcomes, confidence, and real-world readiness"
        : "Nous nous concentrons sur les résultats, la confiance et la préparation au monde réel",
  },
];

  return (
    <section className="Why_Choose_Ambassadeur">
      <div className="container">

        {/* <Common_subHeading subHeading="Why Students Choose AFI" /> */}

        <Common_subHeading 
  subHeading={
    language == 1 
      ? "Why Students Choose AFI" 
      : "Pourquoi les étudiants choisissent AFI"
  } 
/>
        <div className="pink_box_holder">
          <div className="row">

            {ambassadeur.map((item, index) => (
              <div className="col-lg-4 col-md-4 col-sm-6 mb-4" key={index}>
                <Pink_box box_text={item.heading} desc_text={item.desc} />
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
}

export default Why_Choose_Ambassadeur;
